class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.closeDelay = null;
    this.openedByHover = false;
    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('pointerenter', this.onPointerEnter);
    this.addEventListener('pointerleave', this.onPointerLeave);
    this.summary.addEventListener('click', this.onSummaryClick);
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.onPointerEnter);
    this.removeEventListener('pointerleave', this.onPointerLeave);
    this.summary.removeEventListener('click', this.onSummaryClick);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    window.clearTimeout(this.closeDelay);
  }

  open() {
    this.closest('.header')
      ?.querySelectorAll('header-menu')
      .forEach((menu) => {
        if (menu !== this) menu.close();
      });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerEnter() {
    if (!this.hoverMedia.matches || this.mainDetailsToggle.open) return;
    window.clearTimeout(this.closeDelay);
    this.openedByHover = true;
    this.open();
  }

  onPointerLeave() {
    if (!this.hoverMedia.matches) return;
    window.clearTimeout(this.closeDelay);
    this.closeDelay = window.setTimeout(() => {
      if (this.openedByHover && !this.matches(':hover') && !this.contains(document.activeElement)) this.close();
    }, 180);
  }

  onSummaryClick(event) {
    if (!this.openedByHover || !this.mainDetailsToggle.open) return;
    event.preventDefault();
    this.openedByHover = false;
    this.summary.setAttribute('aria-expanded', true);
  }

  onDocumentPointerDown(event) {
    if (this.mainDetailsToggle.open && !this.contains(event.target)) this.close();
  }

  close() {
    super.close();
    this.openedByHover = false;
  }

  onToggle() {
    if (!this.header) return;
    if (!this.mainDetailsToggle.open) this.openedByHover = false;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
